// 9fbef606107a605d69c0edbcd8029e5d
import { getBrand, getAPIConfig } from '@tcp/core/src/utils';
import appBannerConfig from './config';
/**
 * This will be used to redirect user to android play store link
 */
export const androidPlayStoreLink = () => {
  const androidDeviceType = 'android';
  const { APP_STORE_LINKS, APP_STORE_IDS } = appBannerConfig;
  const brandName = getBrand();
  const appId = APP_STORE_IDS[brandName]?.appID[androidDeviceType];
  return `${APP_STORE_LINKS[androidDeviceType]}${appId}`;
};

/**
 * This function will return the IOS app Playstore URl
 */
export const getIOSAppStoreDetail = () => {
  const iosDeviceType = 'ios';
  const { APP_STORE_LINKS, APP_STORE_IDS } = appBannerConfig;
  const brandName = getBrand();
  const appId = APP_STORE_IDS[brandName]?.appID[iosDeviceType];
  return `${APP_STORE_LINKS[iosDeviceType]}${appId}`;
};

export const getAppID = (type) => {
  const { APP_STORE_IDS } = appBannerConfig;
  const brandName = getBrand();
  return APP_STORE_IDS[brandName]?.appID[type];
};

export const getAppInstallPageUrl = () => {
  const brandId = getBrand();
  const { webDomainName } = getAPIConfig();
  return `${webDomainName}/app-install.html?brand=${brandId}`;
};
